<template>
  <div class="footContainer">
    <div class="foot">
      <div class="contactUs">
        <p @click="callPhone">电话: 4000-029-428</p>
        <p>邮箱: sxsbjxh@163.com</p>
        <p>投稿邮箱: dzyxjy@163.com</p>
        <p>地址: 陕西省西安市雁塔西路76号</p>
      </div>
      <div class="qrcodeList">
        <div class="code">
          <p>
            <b>扫码使用医生协作</b>
          </p>
          <div class="codeImg">
            <img src="./../../assets/code3.jpg" />
          </div>
        </div>
        <div class="code">
          <p>
            <b>扫码关注大众教育</b>
          </p>
          <div class="codeImg">
            <img src="./../../assets/code2.jpg" />
          </div>
        </div>
        <div class="code">
          <p>
            <b>微信扫码关注学会</b>
          </p>
          <div class="codeImg">
            <img src="./../../assets/newcode.jpg" />
          </div>
        </div>
      </div>
      <div class="copy">
        <div
          style="
            min-height: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <p style="margin-right: 10px">Copyright 2003-{{ times }}</p>
          <p style="margin-right: 10px">陕西省保健学会版权所有</p>
          <p>
            <a
              href="https://beian.miit.gov.cn"
              style="color: #eaf0eb; text-decoration: none"
              >陕ICP备18015315号</a
            >
          </p>
        </div>
        <div
          style="
            width: 300px;
            margin: 0 auto;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61011302000802"
            style="
              display: inline-block;
              text-decoration: none;
              height: 20px;
              line-height: 20px;
            "
            ><img src="./../../assets/copyIcon.png" style="float: left" />
            <p
              style="
                float: left;
                height: 20px;
                line-height: 20px;
                margin: 0px 0px 0px 5px;
                color: #ffffff;
              "
            >
              陕公网安备 61011302000802号
            </p></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "phoneFoot",
  data() {
    return {
      times: "2021",
    };
  },
  methods: {
    callPhone() {
      window.location.href = "tel://4000029428";
    },
  },
  mounted() {
    var newdata = new Date(),
      year = newdata.getFullYear();
    this.times = year;
  },
};
</script>

<style lang="less" scoped>
@base: #3e8f83;
@baseBase: #eaf0eb;
.footContainer {
  width: 100%;
  height: auto;
  background-color: @base;
}
.foot {
  height: auto;
  width: 92%;
  padding: 0.3rem 4%;
  box-sizing: content-box;
  overflow: hidden;
  color: #fff;
}
.qrcodeList {
  margin: 10px 0;
  overflow: hidden;
  .code {
    width: 33.333333%;
    float: left;
    p {
      margin-bottom: 2px;
      font-size: 12px;
      text-align: center;
    }
    .codeImg {
      width: 90%;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.contactUs {
  text-align: center;
  margin-top: 0.1rem;
  p {
    margin-bottom: 0px;
    font-size: 12px;
    line-height: 0.35rem;
  }
}
.copy {
  width: 100%;
  border-top: 1px solid #fff;
  text-align: center;
  p {
    display: inline-block;
    margin-bottom: 0px;
    font-size: 12px;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/phone/phoneFoot.vue